module.exports = __webpack_public_path__ + "img/image_3.ced1df6e.png";